// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3hiE_","selects":"Documents_selects__1PDB4"};